import { ResetPasswordForm } from "wasp/client/auth";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { AuthPageLayout } from "../AuthPageLayout";
import useTranslation from "../../client/hooks/useTranslation";

export function PasswordResetPage() {
  const t = useTranslation();
  return (
    <AuthPageLayout>
      <ResetPasswordForm appearance={{ colors: { brand: 'hsl(var(--primary))', brandAccent: 'hsl(var(--primary))', submitButtonText: '#ffffff' } }} />
      <br />
      <span className="text-sm font-medium text-gray-900 dark:text-gray-900">
        {t.auth.ifEverythingOk}{" "}
        <WaspRouterLink to={routes.LoginRoute.to} className="underline">
          {t.auth.goToLogin}
        </WaspRouterLink>
        .
      </span>
    </AuthPageLayout>
  );
}
